import { useTranslation } from 'react-i18next';
import { ReactComponent as PhoneIcon } from 'src/assets/img/icons/phone-dashboard-icon.svg';
import { ReactComponent as DollarIcon } from 'src/assets/img/icons/dollar-dashboard-icon.svg';
import { ReactComponent as PercentIcon } from 'src/assets/img/icons/percent-dashboard-icon.svg';
import { ReactComponent as ListIcon } from 'src/assets/img/icons/list-dashboard-icon.svg';
import { ReactComponent as NewsPaperIcon } from 'src/assets/img/icons/newspaper-dashboard-icon.svg';

import DashboardStatsItem from './DashboardStatsItem';
import cls from './DashboardStats.module.scss';
import { useEffect, useState } from 'react';

interface IDashboardStatsProps {
  leads: number | undefined;
  avg_check: number | undefined;
  avg_check_percent: number | undefined;
  avg_margin: number | undefined;
  avg_upsale: number | undefined;
  isLoading: boolean;
}

const DashboardStats = ({
  leads,
  avg_margin,
  avg_upsale,
  avg_check,
  avg_check_percent,
  isLoading,
}: IDashboardStatsProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'dashboard-stats' });
  const { t: tg } = useTranslation('translation');
  const [stats, setStats] = useState([
    { icon: PhoneIcon, title: t('leads'), value: 0 },
    {
      icon: DollarIcon,
      title: t('avg-check', { value: tg('currency-hrn') }),
      value: 0,
    },
    {
      icon: PercentIcon,
      title: t('avg-check', { value: '%' }),
      value: 0,
    },
    { icon: ListIcon, title: t('avg-margin'), value: 0 },
    { icon: NewsPaperIcon, title: t('avg-upsale'), value: 0 },
  ]);

  useEffect(() => {
    if (!isLoading) {
      const updatedValues = [
        leads,
        avg_check,
        avg_check_percent,
        avg_margin,
        avg_upsale,
      ];

      setStats((prev) =>
        prev.map((stat, index) => ({
          ...stat,
          value: updatedValues[index] ?? 0,
        }))
      );
    }
  }, [isLoading, leads, avg_check, avg_check_percent, avg_margin, avg_upsale]);

  return (
    <ul className={cls['dashboard-stats']}>
      {stats.map((stat, index) => (
        <DashboardStatsItem key={index} {...stat} isLoading={isLoading} />
      ))}
    </ul>
  );
};

export default DashboardStats;
